import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getReferralDetails} from '../../services/referrals.services';

export const useGetReferralDetailsQuery = (cdSenha?: string) =>
	useQuery({
		queryKey: [QUERY_KEYS.GET_REFERRAL_DETAILS, cdSenha],
		queryFn: async ({signal}) => getReferralDetails(cdSenha!, signal),
		retry: 1,
		enabled: !!cdSenha,
	});
